var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("fade-transition", { attrs: { duration: 250, mode: "out-in" } }, [
          !_vm.data.headphone
            ? _c("div", { key: "1" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center mb-1 mb-md-5" },
                  [
                    _c("span", { staticClass: "header header-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "hearing_test_configuration.headphone_selection_header"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column align-items-center flex-md-row justify-content-md-around mt-1 mt-md-5"
                  },
                  _vm._l(_vm.headphoneTypes, function(headphone) {
                    return _c(
                      "div",
                      {
                        key: headphone.id,
                        staticClass: "headphones-selection",
                        on: {
                          click: function($event) {
                            return _vm.selectHeadphones(headphone)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: "public/" + headphone.image, alt: "" }
                        })
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { key: "2" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center mb-3" },
                  [
                    _c("span", { staticClass: "header header-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "hearing_test_configuration.personal_informations"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("form", { staticClass: "form", attrs: { novalidate: "" } }, [
                  _c("div", { staticClass: "form-row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2"
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.user.birthdate,
                                expression: "data.user.birthdate"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "selectage" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.data.user,
                                  "birthdate",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { disabled: "", selected: "" },
                                domProps: { value: null }
                              },
                              [_vm._v(_vm._s(_vm.$t("form.age")))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.ageGroupOptions, function(
                              ageGroup,
                              index
                            ) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  domProps: { value: ageGroup.value }
                                },
                                [_vm._v(_vm._s(ageGroup.label))]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2 pl-2 pr-2"
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "custom-label",
                            attrs: { for: "age-group" }
                          },
                          [_vm._v(_vm._s(_vm.$t("form.gender.title")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          _vm._l(_vm.genderOptions, function(gender, index) {
                            return _c(
                              "span",
                              { staticClass: "checkbox__container" },
                              [
                                _vm.data.user.gender == gender.value
                                  ? _c("span", {
                                      staticClass: "i-checkbox-selected",
                                      on: {
                                        click: function($event) {
                                          _vm.data.user.gender = gender.value
                                        }
                                      }
                                    })
                                  : _c("span", {
                                      staticClass: "i-checkbox",
                                      on: {
                                        click: function($event) {
                                          _vm.data.user.gender = gender.value
                                        }
                                      }
                                    }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "checkbox__label",
                                    attrs: { for: "checkbox1" }
                                  },
                                  [_vm._v(_vm._s(gender.label))]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between mt-5" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.data.headphone = null
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("actions.back")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button primary",
                        class: { disabled: _vm.data.user.birthdate === null },
                        attrs: {
                          type: "button",
                          disabled: _vm.data.user.birthdate === null
                        },
                        on: { click: _vm.saveInfo }
                      },
                      [_vm._v(_vm._s(_vm.$t("actions.start")))]
                    )
                  ]
                )
              ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }